class MediaBlock {
	static SELECTOR_CLASS_BLOCK = '.wp-block-jtf-jtf-youtube'
	static SELECTOR_CLASS_MEDIA_BLOCK = '.jtf__mediablock'
	static SELECTOR_CLASS_PLACEHOLDER = '.jtf__mediablock__placeholder'
	static SELECTOR_CLASS_MEDIA_BLOCK_YT = '.jtf__mediablock--yt'
	static SELECTOR_CLASS_TAB_TOGGLE = '.wp-block-jtf-jtf-tab-toggle-content'
	static SELECTOR_CLASS_TAB_CONTENT = '.jtf__tabtoggleblock__content'
	static SELECTOR_CLASS_TAB_ITEM = '.jtf__tabtoggleblock__items__item'
	static SELECTOR_CLASS_ADMIN = '.wp-admin'
	static ATTR_URL = 'data-url'
	static ATTR_TYPE = 'data-type'
	static ATTR_ASPECT_H = 'data-aspecth'
	static ATTR_ASPECT_W = 'data-aspectw'
	static ATTR_ID = 'id'
	static PROP_ADMIN_TIMEOUT = 4000
	static PROP_RESIZE_TIMEOUT = 100
	static PROP_VIDEO_TYPE_VIMEO = 'vm'
	static PROP_VIDEO_TYPE_YOUTUBE = 'yt'
	static PROP_VIDEO_TYPE_WISTIA = 'ws'
	static PROP_VIDEO_TYPE_BILIBILI = 'bb'
	static PROP_VIDEO_TYPE_GOTOWEBINAR = 'gtw'
	static PROP_API_SRC_YOUTUBE = 'https://www.youtube.com/iframe_api'

	constructor( context ) {
		this.instance = context
		this.init()
		this.embedVideo()
	}

	init() {
		if ( this.instance.querySelector( MediaBlock.SELECTOR_CLASS_MEDIA_BLOCK_YT ) ) {
			this.loadYouTubeAPI()
		}

		this.resizeOnWindowChange()

		window.addEventListener( 'resize', () => {
			this.resizeOnWindowChange()
		} )

		const tabToggleExists = document.querySelector( MediaBlock.SELECTOR_CLASS_TAB_TOGGLE )
		const tabContentExists = document.querySelector( MediaBlock.SELECTOR_CLASS_TAB_CONTENT )

		if ( tabToggleExists && tabContentExists ) {
			const tabItems = document.querySelectorAll( MediaBlock.SELECTOR_CLASS_TAB_ITEM )
			tabItems.forEach( ( tabItem ) => {
				tabItem.addEventListener( 'click', () => {
					const tabId = tabItem.getAttribute( MediaBlock.ATTR_ID )
					const tabContentElem = document.getElementById( `${ tabId }Content` )
					if ( tabContentElem && tabContentElem.contains( this.instance ) ) {
						setTimeout( () => {
							this.resizeOnWindowChange()
						}, MediaBlock.PROP_RESIZE_TIMEOUT )
					}
				} )
			} )
		}
	}

	embedVideo() {
		this.instance.addEventListener( 'click', ( e ) => {
			const placeholder = e.target.closest( MediaBlock.SELECTOR_CLASS_PLACEHOLDER )
			if ( !placeholder ) {
				return
			}

			e.preventDefault()
			const parent = placeholder.parentElement
			const videoID = parent.getAttribute( MediaBlock.ATTR_URL )
			const videoType = parent.getAttribute( MediaBlock.ATTR_TYPE )
			const thisAspectH = placeholder.getAttribute( MediaBlock.ATTR_ASPECT_H )
			const thisAspectW = placeholder.getAttribute( MediaBlock.ATTR_ASPECT_W )
			const thisWidth = placeholder.offsetWidth
			const oneOfThisWidth = thisWidth / thisAspectW

			placeholder.remove()

			switch ( videoType ) {
				case MediaBlock.PROP_VIDEO_TYPE_VIMEO: {
					parent.insertAdjacentHTML( 'beforeend',
						`<iframe width="100%" height="${ oneOfThisWidth * thisAspectH }px" src="https://player.vimeo.com/video/${ videoID }?badge=0&autopause=0&player_id=0&autoplay=1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen loading="lazy"></iframe><script src="https://player.vimeo.com/api/player.js"></script>`,
					)
					break
				}
				case MediaBlock.PROP_VIDEO_TYPE_YOUTUBE: {
					this.createYoutubeIframeEmbed( parent, oneOfThisWidth, thisAspectH, videoID )
					break
				}
				case MediaBlock.PROP_VIDEO_TYPE_WISTIA: {
					parent.insertAdjacentHTML( 'beforeend',
						`<script src="https://fast.wistia.com/embed/medias/${ videoID }.jsonp" async></script>` +
						`<script src="https://fast.wistia.com/assets/external/E-v1.js" async></script>` +
						`<div class="wistia_embed wistia_async_${ videoID } autoPlay=true" style="height:${ oneOfThisWidth * thisAspectH }px;width:100%">&nbsp;</div>`,
					)
					break
				}
				case MediaBlock.PROP_VIDEO_TYPE_BILIBILI: {
					parent.insertAdjacentHTML( 'beforeend',
						`<iframe width="100%" height="${ oneOfThisWidth * thisAspectH }px" src="https://player.bilibili.com/player.html?bvid=${ videoID }&autoplay=1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen loading="lazy"></iframe>`,
					)
					break
				}
				case MediaBlock.PROP_VIDEO_TYPE_GOTOWEBINAR: {
					parent.insertAdjacentHTML( 'beforeend',
						`<iframe width="100%" height="${ oneOfThisWidth * thisAspectH }px" src="https://app.gotowebinar.com/unified/index.html#/embedded/recording/${ videoID }?source=G2S-EMBEDDED" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen loading="lazy"></iframe>`,
					)
					break
				}
				default: {
					break
				}
			}
		} )
	}

	createYoutubeIframeEmbed( parent, oneOfThisWidth, thisAspectH, videoID ) {
		new YT.Player( parent, {
			height: `${ oneOfThisWidth * thisAspectH }px`,
			width: '100%',
			videoId: videoID,
			playerVars: {
				'autoplay': 1,
				'playsinline': 1,
				'rel': 0,
				'modestbranding': 1,
				'showinfo': 0,
				'controls': 1,
			},
			events: {
				'onReady': ( event ) => {
					event.target.playVideo()
				},
			},
		} )
	}

	loadYouTubeAPI() {
		if ( document.querySelector( `script[src="${ MediaBlock.PROP_API_SRC_YOUTUBE }"]` ) ) {
			return
		}

		const tag = document.createElement( 'script' )
		const firstScriptTag = document.getElementsByTagName( 'script' )[ 0 ]
		tag.src = MediaBlock.PROP_API_SRC_YOUTUBE
		firstScriptTag.parentNode.insertBefore( tag, firstScriptTag )
	}

	resizeOnWindowChange() {
		const mediaBlock = this.instance.querySelector( MediaBlock.SELECTOR_CLASS_MEDIA_BLOCK )
		if ( !mediaBlock ) {
			return
		}

		const button = mediaBlock.querySelector( 'button' )
		if ( !button ) {
			return
		}

		const thisAspectH = button.getAttribute( MediaBlock.ATTR_ASPECT_H )
		const thisAspectW = button.getAttribute( MediaBlock.ATTR_ASPECT_W )
		const thisWidth = mediaBlock.offsetWidth
		const oneOfThisWidth = thisWidth / thisAspectW
		const newHeight = oneOfThisWidth * thisAspectH

		const placeholder = this.instance.querySelector( MediaBlock.SELECTOR_CLASS_PLACEHOLDER )
		if ( placeholder ) {
			placeholder.style.height = `${ newHeight }px`
		}

		const iframe = mediaBlock.querySelector( 'iframe' )
		if ( iframe ) {
			iframe.setAttribute( 'height', `${ oneOfThisWidth * thisAspectH }px` )
		}
	}
}

export default function init() {
	if ( document.querySelector( MediaBlock.SELECTOR_CLASS_ADMIN ) ) {
		setTimeout( () => {
			const blocks = document.querySelectorAll( MediaBlock.SELECTOR_CLASS_BLOCK )
			blocks.forEach( ( block ) => {
				new MediaBlock( block )
			} )
		}, MediaBlock.PROP_ADMIN_TIMEOUT )
	} else {
		const blocks = document.querySelectorAll( MediaBlock.SELECTOR_CLASS_BLOCK )
		blocks.forEach( ( block ) => {
			new MediaBlock( block )
		} )
	}
}
